import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const CartOutlinedSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.7846 3.09219L17.5281 7.99609H6.47195L10.2154 3.09219L8.78461 2L4.20744 7.99609H0L0.735683 15.4634H0.738155C1.29875 20.3545 3.43303 21.9961 9.11688 21.9961H14.8831C20.567 21.9961 22.7012 20.3545 23.2618 15.4634H23.2643L24 7.99609H19.7926L15.2154 2L13.7846 3.09219ZM2.52644 15.2585C2.7848 17.5126 3.35996 18.5588 4.11117 19.1429C4.93045 19.7799 6.36571 20.1961 9.11688 20.1961H14.8831C17.6343 20.1961 19.0695 19.7799 19.8888 19.1429C20.64 18.5588 21.2152 17.5126 21.4736 15.2585L22.014 9.79609H1.98604L2.52644 15.2585Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const CartOutlinedSize24 = hoc(forwardRef(CartOutlinedSize24Component), 'CartOutlinedSize24');

export { CartOutlinedSize24 as default };
//# sourceMappingURL=CartOutlinedSize24.js.map
